import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
export default class Confirmacion extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {}
  handleClickConfirmar = () => {
    //this.props.confirmarBtn();
    this.modalControl.click();
    //this.linkSeprelad.click();
  };
  handleClickRechazar = () => {
    //  this.modalControl.click();
  };

  render() {
    return (
      <div className="modal fade" id="idModalConfirm">
        <div className="modal-dialog  modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fa fa-check" aria-hidden="true" /> Sus datos han
                sido modificados correctamente.
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div>
                <div className="row">
                  <div className="col-12">
                    <div>
                      <section className="content">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12">
                              <p>{this.props.mensaje}</p> <br />
                              <a
                                className="btn btn-outline-success"
                                href="https://cu24hs.cu.coop.py/archivos/Formulario-SEPRELAD.pdf"
                                target="_blank"
                              >
                                <i className="fas fa-link" /> Formulario
                                SEPRELAD
                              </a>
                            </div>
                          </div>
                          <hr />
                          <div className="row invoice-info">
                            <div className="col-md-6">
                            <button
                                onClick={this.handleClickConfirmar}
                                type="button"
                                className="btn btn-cu-primary"
                              >
                              <FontAwesomeIcon icon={faCheck} />  Aceptar
                              </button>
                            </div>
                            <div className="col-md-6">
                            <button
                                ref={(a) => (this.modalControl = a)}
                                hidden
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">CERRAR</span>
                              </button>
                            </div>
                           
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
